import React, { useContext } from "react";
import { useField } from "formik";
import FieldError from "../../shared/FieldError";
import { Settings } from "../../helpers/Contexts";
import { MdWarning } from "react-icons/md";

const SelectVisitType = ({ setFieldValue, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const { setTouched } = helpers;
  const [awv, setAwv] = React.useState(null);

  const settings = useContext(Settings);

  const handleChange = (val) => {
    const selected = settings.visit_types.find((i) => (i.id == val ? i : ""));
    (selected.name == "Annual Wellness Visit" ||
      selected.name == "Telehealth Visit - Annual Wellness Visit (AWV)") &&
    props.showPopup
      ? setAwv(selected.name)
      : setAwv(null);
    setFieldValue("procedure_type", selected.name);
    setFieldValue("procedure_type_id", val);
  };
  return (
    <>
      <label>Visit Type</label>
      <select
        name={"procedure_type"}
        value={props.value}
        onChange={(e) => {
          setTouched(true);
          handleChange(e.target.value);
        }}
      >
        {field.value}
        {!field.value && <option value="">Select a visit type</option>}
        {settings.visit_types.map((i) => (
          <option key={i.id} value={i.id}>
            {i.name}
          </option>
        ))}
      </select>
      {props.showPopup && awv && (
        <div className="awv-pop-up">
          <MdWarning />
          <h6>
            Are you sure this patient completed a(n) <b>{awv}</b>?
          </h6>
          Please review the visit summary and/or superbill.
          If you do not see CPT codes 99381–99397 or ICD-10 codes Z00.00 or Z00.01 listed, this was not an Annual Wellness Visit (AWV), and you will need to select a different visit type.
        </div>
      )}
      {meta.error && !field.value ? <FieldError error={meta.error} /> : null}
    </>
  );
};
export default SelectVisitType;
